import AnswerStatusChip from "@memorang/ui/src/components/AnswerStatusChip";
import Box from "@memorang/ui/src/components/Box";
import TooltipWrapper from "@memorang/ui/src/components/TooltipWrapper";
import pluralize from "pluralize";

type AnswerStatusRowProps = {
	numCorrect: number;
	numIncorrect: number;
	numSkipped: number;
	tagLabel?: string;
};

const AnswerStatusRow = ({
	numCorrect,
	numIncorrect,
	numSkipped,
	tagLabel = "this topic",
}: AnswerStatusRowProps) => {
	const totalItems = numCorrect + numIncorrect + numSkipped;

	return (
		<Box flexDirection="row" alignItems="center" gap={8}>
			<TooltipWrapper
				title={`You answered ${numCorrect} ${pluralize("item", numCorrect)} correctly out of ${totalItems} ${pluralize("item", totalItems)} in ${tagLabel}`}
			>
				<AnswerStatusChip status={"correct"} label={`${numCorrect}`} />
			</TooltipWrapper>
			<TooltipWrapper
				title={`You answered ${numIncorrect} ${pluralize("item", numIncorrect)} incorrectly out of ${totalItems} ${pluralize("item", totalItems)} in ${tagLabel}`}
			>
				<AnswerStatusChip status={"incorrect"} label={`${numIncorrect}`} />
			</TooltipWrapper>
			<TooltipWrapper
				title={`You skipped ${numSkipped} ${pluralize("item", numSkipped)} out of ${totalItems} ${pluralize("item", totalItems)} in ${tagLabel}`}
			>
				<AnswerStatusChip status={"skipped"} label={`${numSkipped}`} />
			</TooltipWrapper>
		</Box>
	);
};

export default AnswerStatusRow;
